import { EChartOption } from 'echarts';
import * as echarts from 'echarts/lib/echarts';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import { timelineDataSelector } from '@store/timeline/data/selectors';
import { TIMELINE_DIMENSION, ALL_DISPLAY_NAMES } from '@components/session-timeline/utils/constants';
import errorImpact from '@components/session-timeline/utils/errorImpact';

const renderItem: any = (params, api) => {
  const point = api.coord([api.value(0)]);
  const height = 25;

  const rectShape = echarts.graphic.clipRectByRect(
    {
      x: point[0],
      y: 15,
      width: 2,
      height,
    },
    {
      x: params.coordSys.x,
      y: 15,
      width:  params.coordSys.width,
      height,
    },
  );

  return (
    rectShape && {
      type: 'rect',
      shape: rectShape,
      style: {fill: '#ddd'},
      styleEmphasis: {
        fill: '#ddd',
        opacity: 1,
      },
    }
  );
};

const useEventOption = (eventKey: string, dateRange: number[]): EChartOption => {

  const min = dateRange[0];
  const max = dateRange[dateRange.length - 1];

  const diff = moment(max).diff(min, 'm');

  const timelineData = useSelector(timelineDataSelector);
  const eventTimelineData = get(timelineData, [eventKey], []) as Array<{ timeMs: number; value: any }>;
  const eventData = eventTimelineData.filter(
    ({ timeMs }) => (timeMs >= min && timeMs <= max)
  ).map(({ timeMs, value }) => ([
    timeMs,
    1,
    value
  ]));

  return {
    tooltip: {},
    grid: {
      show: true,
      left: 20,
      right: 95,
      top: 15,
      bottom: 20,
      borderWidth: 0,
      backgroundColor: '#F6F6F6',
      shadowColor: 'rgba(0, 0, 0, 0.1)',
      shadowBlur: 0.5,
      shadowOffsetY: 1,
    },
    xAxis: {
      type: 'time',
      left: 30,
      right: 95,
      bottom: 20,
      height: 20,
      splitNumber: Math.min(14, diff),
      min,
      max,
      data: dateRange,
      axisLine: { show: false },
      splitLine: { show: false },
      axisLabel: {
        showMinLabel: true,
        showMaxLabel: true,
        formatter: value => moment(value).format('HH:mm'),
      },
      axisTick: { show: false },
    },
    yAxis: [{
      axisLine: { show: false },
      splitLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        show: false,
        showMinLabel: false,
        showMaxLabel: false,
      },
    }],
    series: [
      {
        type: 'custom',
        renderItem,
        data: eventData,
        itemStyle: {
          color: '#A9A9A9',
        },
        tooltip: {
          formatter: params => {
            const [time, index, value] = get(
              params,
              ['value'],
              ['N/A', 1, ''],
            );
            switch (eventKey) {
            case TIMELINE_DIMENSION.Error:{
              const { type: errorType, errorMessage } = value;
              return `
                <table class="error-table">
                <tr><td><strong>${moment(time).format('MMM DD, YYYY HH:mm:ss')}</strong></td></tr>
                <tr><td class="value">${errorMessage}</td></tr>
                <tr><td>${ALL_DISPLAY_NAMES[errorType] || errorType}</td></tr>
                <tr><td>${`Impact: ${errorImpact(value)}`}</td></tr>
                </table>
              `;
            }
            case TIMELINE_DIMENSION.CustomEvent:{
              const { name } = value;
              return `
                <div><strong>${moment(time).format('MMM DD, YYYY HH:mm:ss')}</strong></div>
                <div>${ALL_DISPLAY_NAMES[name] || name}</div>
              `;
            }
            default:
              return ''
            }
          },
        },
      },
    ],
  };
};

export default useEventOption;
